import type { PortalPromoDto } from '@supply-mover-2-0/shared';
import type { JSX } from 'react';
import { PromoTile } from './PromoTile';
import type { PromoClickTarget } from './promoClickTarget';

/**
 * Side-by-side pair of feature tiles. Renders the first two selected
 * promos.
 */
export function PromoTwoUpWidget({
	promos,
	density,
	onSelect,
	onLikelyStaleUrl,
}: {
	promos: Array<PortalPromoDto>;
	density?: 'standard' | 'compact';
	/**
	 * Forwarded to each tile. Omit to render tiles inert (CRM
	 * designer preview). See `PromoTile.onSelect`.
	 */
	onSelect?: (target: PromoClickTarget) => void;
	/** Forwarded to each PromoTile. See `PromoTile.onLikelyStaleUrl`. */
	onLikelyStaleUrl?: () => void;
}): JSX.Element | null {
	const slice = promos.slice(0, 2);
	if (slice.length === 0) return null;
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 gap-3 w-full h-full">
			{slice.map((p) => (
				<PromoTile
					key={p.id}
					promo={p}
					size="feature"
					density={density}
					onSelect={onSelect}
					onLikelyStaleUrl={onLikelyStaleUrl}
				/>
			))}
		</div>
	);
}
